import { Button, Progress, Tooltip } from 'antd';
import { useContext, useState } from 'react';
import { LibraryContext } from './context-provider';
import UploadDrawer from './upload-drawer';

export default function UploadProgress() {
   const [progress, setProgress] = useState(50);
   const [openDrawer, setOpenDrawer] = useState(false);
   const { uploadProgress } = useContext(LibraryContext);

   function handleUpload() {
      setOpenDrawer(true);
   }

   if (!uploadProgress || uploadProgress === 0) return null;

   return (
      <>
         <UploadDrawer open={openDrawer} setOpen={setOpenDrawer} />
         <Tooltip title={`Uploading ${uploadProgress}%`}>
            <Button type="text" onClick={() => handleUpload()}>
               <Progress type="circle" percent={uploadProgress} showInfo={false} width={16} strokeWidth={12} />
            </Button>
         </Tooltip>
      </>
   );
}
